import _ from 'lodash';

import type { CycleAccueilType, IndicateursCleType } from '@/types';
import { formatMonetaire } from '@/utils';
import TileBase from './TileBase';
import TileHeader from './TileHeader';

type TileChiffresMoisPropsType = {
  indicateurs: IndicateursCleType | null;
  cycles: CycleAccueilType[];
  loading?: boolean;
};

const TileChiffresMois = ({ indicateurs, cycles, loading }: TileChiffresMoisPropsType) => {
  // Somme des montants encaissés de tous les cycles
  const montantEncaisses = _.sumBy(cycles, 'montantEncaisse');

  return (
    <TileBase className="tile-chiffres-mois" loading={loading}>
      <TileHeader title="Les chiffres du mois" />

      <div className="chiffres-mois-grid">
        <div className="chiffre-mois-box">
          <span className="chiffre-mois-value">{formatMonetaire(montantEncaisses, 2, true)}</span>
          <span className="chiffre-mois-label">encaissés</span>
        </div>

        <div className="chiffre-mois-box">
          <span className="chiffre-mois-value">
            {formatMonetaire(indicateurs?.montantsAEncaisser || 0, 2, true)}
          </span>
          <span className="chiffre-mois-label">restent à encaisser</span>
        </div>
      </div>
    </TileBase>
  );
};

export default TileChiffresMois;
